'use client';
import { useTheme } from '@mui/material';

export const getClientNonce = () => useTheme().custom.nonce;
